"use client";
import React from "react";
import Image from "next/image";
import { Box, Center, HStack } from "@chakra-ui/react";
import { Heading } from "@/elements";
import AmdLogo from "public/pricingPage/amd.webp";
import IntelLogo from "public/pricingPage/intel.png";
import AmdWLogo from "public/pricing/amd-w-logo.png";
import IntelWLogo from "public/pricing/intel-logo-white.png";
import IntelDedicatedPricing from "@/views/pricing/components/tables/cloudVm/intelDedicated";
import AmdDedicatedPricing from "@/views/pricing/components/tables/cloudVm/amdDedicated";
import { PRICING_HEADING_CONSTANTS } from "./constants";

export const tablist = [
  {
    component: <IntelDedicatedPricing />,
    label: ({ isSelected }) => (
      <Center>
        <HStack gap={1}>
          <Box
            h="1.5rem"
            position="relative"
            w="2.5rem"
            display={"flex"}
            alignItems={"center"}
            mr={"10px"}
          >
            <Image
              src={isSelected ? IntelWLogo : IntelLogo}
              alt="image"
              sizes="38px"
              style={{ objectFit: "contain" }}
            />
          </Box>
          <Heading fontWeight={600} variant={"subTitle3"}>
            {PRICING_HEADING_CONSTANTS.organization_server}
          </Heading>
        </HStack>
      </Center>
    ),
  },
  {
    component: <AmdDedicatedPricing />,
    label: ({ isSelected }) => (
      <Center>
        <HStack gap={1}>
          <Box
            h="1.5rem"
            position="relative"
            w="2.5rem"
            display={"flex"}
            alignItems={"center"}
            mr={"10px"}
          >
            <Image
              src={isSelected ? AmdWLogo : AmdLogo}
              alt="image"
              sizes="38px"
              style={{ objectFit: "contain" }}
            />
          </Box>
          <Heading fontWeight={600} variant={"subTitle3"}>
            {PRICING_HEADING_CONSTANTS.user_server}
          </Heading>
        </HStack>
      </Center>
    ),
  },
];
